import { render, staticRenderFns } from "./CustoUpdateReportModal.vue?vue&type=template&id=0bca082c&scoped=true"
import script from "./CustoUpdateReportModal.vue?vue&type=script&lang=js"
export * from "./CustoUpdateReportModal.vue?vue&type=script&lang=js"
import style0 from "./CustoUpdateReportModal.vue?vue&type=style&index=0&id=0bca082c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca082c",
  null
  
)

export default component.exports